import { resolveCardIcon } from 'lib/helpers/resolveCardIcon';

import Icon from 'components/shared/Icon/Icon';
import Disclosure from 'components/shared/Disclosure/Disclosure';
import Typography from 'components/shared/Typography/Typography';
import { Caption } from 'components/Patient/checkin/SecurePayment/components/PayWithCardModal/SavedCards';

const CardOption = ({ card, isSelected, note, badge, onSelect }) => (
  <Disclosure
    radio
    disableOpen
    isOpen={isSelected}
    onToggle={() => onSelect(card.id)}
    icon={<Icon icon={resolveCardIcon(card.cardNumber || card.pan)} size="" className="shrink-0" />}
    trailing={badge}
    buttonClassName="items-center gap-2 py-2.5"
    customTitle={
      <div className="flex min-w-0 flex-col">
        <Typography variant="p" size="small" weight="medium" className="truncate">
          {card.name}
        </Typography>
        <Caption card={card} />
        {note && (
          <Typography variant="p" size="small" color="neutral-700">
            {note}
          </Typography>
        )}
      </div>
    }
  />
);

export default CardOption;
